import { transition } from '@helpers/animate';
import { siteWide } from '@helpers/grid';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Container = styled.nav `
  color: var(--fgColor);
  background: var(--bgColor);
  min-width: 0;
`;
const Inner = styled.div `
  ${siteWide};

  margin-top: calc(var(--sectionSpacing) * 0.5);

  ${Container}[data-bottom-spacing='false'] & {
    margin-bottom: calc(var(--sectionSpacing) * -0.5);
  }

  ${Container}[data-bottom-spacing='true'] & {
    margin-bottom: calc(var(--sectionSpacing) * 0.5);
  }

  &[data-layout='default'] {
    max-width: 1040px;
  }
`;
const List = styled.ul `
  ${scrollbars};

  display: flex;
  align-items: center;
  overflow-x: auto;
  padding-bottom: 2px;
  white-space: nowrap;
`;
const Item = styled.li `
  font-weight: 400;

  display: inline-flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  margin-right: 12px;

  &[data-first-link='true'] {
    font-weight: 700;

    line-height: 22px;
  }

  > svg {
    display: block;
    height: 7px;
    width: 4px;
  }
`;
const ItemLink = styled.a `
  ${transition('text-decoration-color')};

  display: inline-block;
  color: currentColor;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  text-decoration-color: transparent;

  &:focus {
    outline: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: var(--textColor);
  }

  &.focus-ring,
  &:hover {
    text-decoration-color: currentColor;
  }

  > svg {
    display: block;
    height: 20px;
    width: 24px;
  }
`;
const BreadcrumbStyles = {
    Container,
    Inner,
    Item,
    ItemLink,
    List,
};
export default BreadcrumbStyles;
